(() => {
  const check = () => {
    const active = (document.documentElement.dataset.tbIdentitySurfaces || '').split(' ').includes('homepage');
    if (active !== Boolean(document.querySelector('[data-bm-homepage]'))) window.location.reload();
  };
  const start = () => new MutationObserver(check).observe(document.documentElement, {attributes:true,attributeFilter:['data-tb-identity-surfaces']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
